import { TId } from '@apia/util';
import { getTabContainer } from './util';
import { TabsController } from '../../../tabs';

export class ApiaUtilTabsController {
  get currentTab() {
    try {
      return getTabContainer().getHandler().getActiveTab();
    } catch (e) {
      e;
    }
    const i = new TabsController('1', { orientation: 'horizontal' });
    i.append({
      content: () => null,
      id: '1',
      label: '',
      tabId: '1',
    });
    return i.getTab('1')!;
  }

  closeTab(tabId: string, force?: boolean) {
    const tabContainer = getTabContainer();
    if (tabContainer !== null) {
      tabContainer.getTab(tabId)?.close(force);
      return;
    }
  }

  getHandler() {
    return getTabContainer()?.getHandler();
  }

  /**
   * openApiaTab y openTab son sinónimos.
   */
  openTab(title: string, url: string): Promise<TId> {
    const tabContainer = getTabContainer();
    if (tabContainer !== null) {
      return tabContainer.addNewTab(title, url);
    }

    return new Promise((resolve) => resolve(''));
  }
}
